const Notify = {
    init() {},
    notify(title, body) {
        let sistemaCpvIcon = '/images/favicon.ico';
        let shouldRequireInteraction = true;
        if (!('Notification' in window)) {
            alert("Browser doesn't support desktop notification");
        } else if (Notification.permission === 'granted') {
            const notification = new Notification(title, {
                body: body,
                icon: sistemaCpvIcon,
                image: sistemaCpvIcon,
                badge: sistemaCpvIcon,
            });
        } else if (Notification.permission !== 'denied') {
            // We need to ask the user for permission
            Notification.requestPermission().then((permission) => {
                // If the user accepts, let's create a notification
                if (permission === 'granted') {
                    const notification = new Notification(title, {
                        body: body,
                        icon: sistemaCpvIcon,
                        requireInteraction: shouldRequireInteraction,
                    });
                }
            });
        }
    },
};

export default Notify;
